import styles from "styles/chat.module.scss";

interface ChatNotFoundProps {
  threadId: string;
}

export default function ChatNotFound({ threadId }: ChatNotFoundProps) {
  return (
    <main className={styles.chat + " vh-100-l vh-100-m"}>
      <div className={styles.chatBody + " pa3"}>
        <div className="center measure-extra-wide pa2 pa0-ns">
          <h1 className="lh-title f2 tc">404: Not found</h1>
          <p className="f5 lh-copy">
            There does not appear to be a chat thread with the ID:{" "}
            <span className="code">{threadId}</span>.
          </p>
        </div>
      </div>
    </main>
  );
}
